import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

import { CircularProgress, ButtonBase, Badge } from "@material-ui/core";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";

import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";

import ChecklistReportsTable from "../../../tables/SO/ChecklistReportsTable";

import history from "../../../utils/history";

const ChecklistReportListView = ({
  soChecklistReports,
  soChecklistReportsLoading,
  visits,
  processRelationships,
  generateReport,
  archive,
  changeArchivedMode,
  isArchivedMode,
}) => {
  const { t } = useTranslation("so");

  return (
    <Card>
      <CardHeader color="info" icon>
        <CardIcon color="info">
          <AssignmentTurnedInIcon />
        </CardIcon>
        <div style={style.left}>
          <h4 style={style.cardTitle}>{t("so.checklistReports.list.title")}</h4>
        </div>
        <div style={style.right}>
          <Button
            size="sm"
            color={!isArchivedMode ? "danger" : "success"}
            onClick={changeArchivedMode}
          >
            {!isArchivedMode ? "Ver Archivados" : "Ver Activos"}
          </Button>
          <Button
            id={"new-report"}
            size="sm"
            color="info"
            onClick={() => history.push(`/so/checklistReport/new`)}
          >
            {t("so.checklistReports.list.buttons.add")}
          </Button>
        </div>
      </CardHeader>
      <CardBody>
        {soChecklistReportsLoading ? (
          <div style={style.progressCnt}>
            <CircularProgress style={style.progress} />
          </div>
        ) : (
          <ChecklistReportsTable
            list={soChecklistReports}
            archive={archive}
            visits={visits}
            processRelationships={processRelationships}
            isArchivedMode={isArchivedMode}
            generateReport={generateReport}
          />
        )}
      </CardBody>
    </Card>
  );
};

ChecklistReportListView.propTypes = {
  soChecklistReports: PropTypes.array.isRequired,
  soChecklistReportsLoading: PropTypes.bool.isRequired,
};

const style = {
  cardTitle: {
    color: "#3C4858",
  },
  progress: {
    margin: "16px",
  },
  progressCnt: {
    width: "100px !important",
    marginLeft: "50%",
    marginRight: "50%",
  },
  cardHeight: {
    height: "430px",
  },
  left: {
    float: "left",
  },
  right: {
    float: "right",
  },
};

export default ChecklistReportListView;
